import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoCloudAiEffect = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.553 3.68394C10.8018 3.0498 11.8577 3.0498 12.1065 3.68395L13.5691 7.41158C14.2211 9.07318 15.7558 10.377 17.7117 10.9309L22.0996 12.1735C22.8461 12.3848 22.8461 13.2818 22.0996 13.4932L17.7117 14.7358C15.7558 15.2896 14.2211 16.5935 13.5691 18.2551L12.1065 21.9827C11.8577 22.6169 10.8018 22.6169 10.553 21.9828L9.09036 18.2551C8.43839 16.5935 6.90362 15.2896 4.94775 14.7358L0.559843 13.4932C-0.186614 13.2818 -0.186614 12.3848 0.559842 12.1735L4.94776 10.9309C6.90362 10.377 8.43839 9.0732 9.09036 7.41162L10.553 3.68394Z",
			fill: "#0578BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.2479 0.317069C37.4138 -0.105692 38.1177 -0.105689 38.2835 0.317074L39.2586 2.80217C39.6932 3.9099 40.7164 4.77914 42.0204 5.14838L44.9456 5.97675C45.4432 6.11767 45.4432 6.71566 44.9456 6.85658L42.0204 7.68495C40.7164 8.05419 39.6932 8.92343 39.2586 10.0312L38.2835 12.5163C38.1177 12.939 37.4138 12.939 37.2479 12.5163L36.2728 10.0311C35.8381 8.92342 34.815 8.0542 33.5111 7.68495L30.5858 6.85658C30.0881 6.71566 30.0881 6.11767 30.5858 5.97675L33.5111 5.14837C34.815 4.77913 35.8381 3.90991 36.2728 2.80219L37.2479 0.317069Z",
			fill: "#0578BE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.8035 32.5898C43.5402 24.2114 36.6662 17.5 28.2239 17.5C19.7816 17.5 12.9077 24.2114 12.6443 32.5898C5.77457 32.6497 0.223877 38.2362 0.223877 45.1201C0.223877 52.0412 5.89257 56 12.8137 56C16.9877 56 39.5761 56 43.75 56C50.6711 56 56.2239 52.0412 56.2239 45.1201C56.2239 38.2362 50.6733 32.6497 43.8035 32.5898ZM38.4019 42.586C37.2083 43.7797 35.2737 43.7805 34.0793 42.586C32.8849 41.3915 30.9137 39.4204 30.9137 39.4204V46.7989C30.9137 48.487 29.5452 49.8555 27.857 49.8555C26.1688 49.8555 24.8005 48.487 24.8005 46.7989V39.4203L21.6348 42.586C20.4412 43.7797 18.506 43.7797 17.3122 42.586C16.1185 41.3924 16.1185 39.4571 17.3122 38.2635C26.3652 29.2105 25.7128 29.8578 25.8351 29.75C27.0527 28.6746 28.8848 28.7462 30.0184 29.88C31.152 31.0137 37.208 37.0698 38.4018 38.2635C39.5955 39.4571 39.5955 41.3924 38.4019 42.586Z",
			fill: "#0578BE"
		})
	]
});
const ForwardRef = forwardRef(SvgIcoCloudAiEffect);
export { ForwardRef as ReactComponent };
